export default __webpack_public_path__ + "media/images/react_icons/minus-c4ebd588e0ff8c9c151378dabab30d63.svg";